import React from 'react';
import './Loginpage.css'; // Assume you create this CSS file
import logo from "./Components/images/Final-logo-SBS.png"; // Assume you have a logo image

const LoginPage = () => {
  return (
    <div className="crm-login-container">
      <h1 className="crm-app-name">CRM System</h1>
      <div className="crm-login-wrapper">
        <div className="crm-logo-section">
          <img
            src={logo}
            alt="Company Logo"
            className="crm-company-logo"
          />
        </div>
        <div className="crm-form-section">
          <h2>Login</h2>
          <form>
            <div className="crm-form-group">
              <label htmlFor="email">Email</label>
              <input type="email" id="email" placeholder="Enter your email" required />
            </div>
            <div className="crm-form-group">
              <label htmlFor="password">Password</label>
              <input type="password" id="password" placeholder="Enter your password" required />
            </div>
            <button type="submit" className="crm-login-button">Login</button>
          </form>
          <div className="crm-form-footer">
            <a href="/forgot-password">Forgot password?</a>
            {/* <a href="/signup">Create an account</a> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;